import { createContext } from 'react';
import useIssueTypes from 'views/root/views/home/views/performance/views/CustomReport/Widgets/useIssueTypes';

const PmDataContext = createContext({
  pmData: {},
  issueTypes: { data: [], loading: true }
});

export const PmDataProvider = ({ children }) => {
  const issueTypes = useIssueTypes();

  return (
    <PmDataContext.Provider value={{ issueTypes }}>
      {children}
    </PmDataContext.Provider>
  );
};

export default PmDataContext;
